"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnySentenceWithSentenceWordFlashcardType = exports.AnySentenceFlashcardTypeSchema = exports.isAnyNonBootcampSentenceFlashcardType = exports.AnyNonBootcampSentenceFlashcardTypeSchema = exports.WordOrderFlashcardTypeSchema = exports.FillInTheBlankRootFlashcardTypeSchema = exports.FillInTheBlankFlashcardTypeSchema = exports.BootcampWordToSentenceFlashcardTypeSchema = exports.BootcampWordOrderFlashcardTypeSchema = exports.BootcampFillInTheBlankFlashcardTypeSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
exports.BootcampFillInTheBlankFlashcardTypeSchema = zod_1.z.literal("UGC_FILL_IN_THE_BLANK");
exports.BootcampWordOrderFlashcardTypeSchema = zod_1.z.literal("UGC_WORD_ORDER");
exports.BootcampWordToSentenceFlashcardTypeSchema = zod_1.z.literal("UGC_WORD_TO_SENTENCE");
exports.FillInTheBlankFlashcardTypeSchema = zod_1.z.literal("FILL_IN_THE_BLANK");
exports.FillInTheBlankRootFlashcardTypeSchema = zod_1.z.literal("FILL_IN_THE_BLANK_ROOT");
exports.WordOrderFlashcardTypeSchema = zod_1.z.literal("WORD_ORDER");
const AnyBootcampSentenceFlashcardTypeSchema = zod_1.z.union([
    exports.BootcampFillInTheBlankFlashcardTypeSchema,
    exports.BootcampWordOrderFlashcardTypeSchema,
    exports.BootcampWordToSentenceFlashcardTypeSchema,
]);
exports.AnyNonBootcampSentenceFlashcardTypeSchema = zod_1.z.union([
    exports.FillInTheBlankFlashcardTypeSchema,
    exports.FillInTheBlankRootFlashcardTypeSchema,
    exports.WordOrderFlashcardTypeSchema,
]);
exports.isAnyNonBootcampSentenceFlashcardType = type_validation_helpers_1.getTypeValidationFunction(exports.AnyNonBootcampSentenceFlashcardTypeSchema);
exports.AnySentenceFlashcardTypeSchema = zod_1.z.union([
    AnyBootcampSentenceFlashcardTypeSchema,
    exports.AnyNonBootcampSentenceFlashcardTypeSchema,
]);
const AnySentenceWithSentenceWordFlashcardTypeSchema = zod_1.z.union([
    exports.AnyNonBootcampSentenceFlashcardTypeSchema,
    exports.BootcampFillInTheBlankFlashcardTypeSchema,
    exports.BootcampWordOrderFlashcardTypeSchema,
]);
exports.isAnySentenceWithSentenceWordFlashcardType = type_validation_helpers_1.getTypeValidationFunction(AnySentenceWithSentenceWordFlashcardTypeSchema);
//# sourceMappingURL=sentence_flashcard_type_types.js.map